/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * The special header that can be added to a request in order to better reference a mock resource.
 */

// required attributes
const SpecialRequestHeaderR = t.interface({
  name: t.string,

  value: t.string
});

// optional attributes
const SpecialRequestHeaderO = t.partial({});

export const SpecialRequestHeader = t.intersection(
  [SpecialRequestHeaderR, SpecialRequestHeaderO],
  "SpecialRequestHeader"
);

export type SpecialRequestHeader = t.TypeOf<typeof SpecialRequestHeader>;
